<template>
  <div class="AuthRegister">
    <transition>
      <div
        v-if="serverValidationErrors.fail"
        class="Notice Notice--danger"
      >
        <div class="Notice-copy">
          {{ serverValidationErrors.fail }}
        </div>
      </div>
    </transition>

    <form
      ref="registration"
      class="Form"
      data-rmpdev-selector="register-form"
    >
      <form-input
        v-model="fields.name"
        :error="validateStatus({ field: v$.fields.name, serverKey: 'name', label: 'Name' })"
        :manual-validate="validateAll"
        has-icon
        required
        icon="far fa-user Icon--left"
        label="Name"
        input-type="text"
        placeholder="Enter your full name"
        @change="validateBlur({ field: v$.fields.name, serverKey: 'name' })"
      />

      <form-input
        v-model="fields.email"
        :error="validateStatus({ field: v$.fields.email, serverKey: 'email', label: 'Email' })"
        :manual-validate="validateAll"
        has-icon
        required
        icon="far fa-envelope Icon--left"
        label="Email"
        input-type="email"
        placeholder="Enter your email address"
        @change="validateBlur({ field: v$.fields.email, serverKey: 'email' })"
      />

      <form-input
        v-model="fields.password"
        :hint="{hint:'(8 or more characters please.)', type:'warning',}"
        :error="validateStatus({ field: v$.fields.password, serverKey: 'password', label: 'Password' })"
        :manual-validate="validateAll"
        has-icon
        required
        icon="far fa-lock Icon--left"
        label="Password"
        input-type="password"
        placeholder="Enter your password"
        @change="validateBlur({ field: v$.fields.password, serverKey: 'password' })"
      />

      <p class="AuthRegister-optinCopy">
        By signing up you agree to our <a href="/terms-and-conditions">Terms of Use</a>.  We will process your information in accordance with our <a href="/privacy-policy">Privacy Policy</a>.
      </p>

      <button
        :class="['Button Button--primary Button--long', {'is-loading' : ui.loading}]"
        @click.prevent="submit"
      >
        Create account
      </button>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { required, minLength, email } from '@vuelidate/validators';
import FormInput from '@/components/form/input';
import ValidationMixin from '@/mixins/validation-mixin';
import useVuelidate from '@vuelidate/core';

export default {
  components: {
    FormInput,
  },
  mixins: [ValidationMixin],
  props: {
    importComment: {
      default: 'Unknown',
      type: String,
    },
    emailOnly: {
      default: false,
      type: Boolean,
    },
    noRedirect: {
      default: false,
      type: Boolean,
    },
    stage: {
      default: null,
      type: Number,
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      fields: {
        name: null,
        email: null,
        password: null,
      },
      serverValidationErrors: [],
      validateAll: false,
      ui: {
        loading: false,
      },
    };
  },
  validations() {
    const rules = {
      fields: {
        email: {
          required, email,
        },
        name: {
          required,
        },
        password: {
          required,
          minLength: minLength(8),
        },
      },
    };

    return rules;
  },
  methods: {
    ...mapActions('user', {
      storeRegisterUser: 'registerUserWithPassword',
    }),
    submit() {
      if (this.ui.loading) {
        return false;
      }

      this.validateAll = true;
      this.v$.$validate();

      if (this.v$.fields.$invalid) {
        this.$emit('register-form:validation-error');
        return false;
      }

      this.serverValidationErrors = {};

      this.ui.loading = true;

      const payload = {
        signin: true,
        email: this.fields.email,
        name: this.fields.name,
        password: this.fields.password,
      };

      if (this.importComment !== null) {
        payload.import_comment = this.importComment;
      }

      return this.storeRegisterUser(payload)
        .then(() => {
          this.loading = false;
          this.$emit('register-form:success');

          if (this.importComment === 'registerInterest') {
            this.$bus.$emit('bus:register-form:success');
          }
        })
        .catch((error) => {
          console.log(error);
          this.ui.loading = false;
          this.error = true;

          // this.$bus.$emit('rmp:register-stage-failed');
          if (error.data.meta.length > 0) {
            error.data.meta.forEach((validationField) => {
              this.serverValidationErrors[validationField.field] = validationField.message;
            });
          }

          this.v$.fields.$touch();

          if (error.status !== 200) {
            this.$bugsnag.notify(new Error('register data form failure'), {
              severity: 'info',
              metaData: {
                'axios-error': error.data,
              },
            });
          }

          this.$emit('register-form:error');

          // Update submit button to default submit state.
          setTimeout(() => {
            this.error = false;
          }, 1000);
        });
    },
  },
};
</script>
<style scoped lang="scss">
  .AuthRegister-optinCopy {
    margin-bottom: 1rem;
    margin-top: 1rem;
    font-size: 13px;
    font-size: 0.8rem;
  }
</style>
